import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const EXIT_MODES = ['Hold', 'Sell']

export function ExitModeControl({ value, onChange }) {
  return (
    <div className="space-y-1.5">
      <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
        Exit Mode
      </p>
      <div
        className="flex rounded-lg border border-border/50 bg-muted/30 p-1"
        role="group"
        aria-label="Exit Mode"
      >
        {EXIT_MODES.map((option) => (
          <Button
            key={option}
            type="button"
            variant="ghost"
            aria-pressed={value === option}
            onClick={() => onChange?.(option)}
            className={cn(
              'h-auto flex-1 rounded-md border border-transparent py-1.5 text-[11px] font-bold text-muted-foreground shadow-none hover:bg-background hover:text-foreground',
              value === option && 'border-border/50 bg-background text-foreground shadow-sm hover:bg-background',
            )}
          >
            {option}
          </Button>
        ))}
      </div>
    </div>
  )
}
